<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" [ngClass]="{'o-grid__cell--right': vm.user?.id===vm.group.user}">
		<div class="o-grid" [ngClass]="{'o-grid--reverse-h': vm.user?.id!==vm.group.user}">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
				<a target="_blank" href="{{vm.media.fileUrl}}" target="_self" class="c-button c-button--icon c-button--tp u-no-p" *ngIf="!vm.media.deleted && vm.media.fileUrl && !vm.media.isPreloading">
					<i class="o-icon o-icon--download c-text c-text--main u-no-m" aria-hidden="true"></i>
					<span class="u-sr-only">{{ 'Common.Download' | translate }}</span>
				</a>
				<i class="o-icon o-icon--attention c-text c-text--s3" aria-hidden="true" *ngIf="vm.media.error"></i>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<div class="chat-message-inner-container" style="display: block;"
					 (mouseenter)="vm.onMouseEnter(vm.media)" (mouseleave)="vm.onMouseLeave(vm.media)" #messageMediaContainer>
					<button class="dots-btn-horizontal"
							*ngIf="!vm.media.deleted && vm.user?.id===vm.media.user.id && (vm.isDesktop ? vm.media.showDots : true)"
							(click)="vm.toggleActions(vm.media, $event, messageMediaContainer)">
						...
					</button>
				<div class="c-message__content c-message__content--fw c-message__content--s2" *ngIf="!vm.media.deleted" [ngClass]="{'u-no-p': vm.media.thumbnailUrl && !vm.media.isPreloading, 'c-message__content--s3': vm.media.error, 'c-message__content--s4': vm.media.isPreloaded}" [ngSwitch]="!!vm.media.thumbnailUrl && !vm.media.isPreloading">
					<div class="c-message__row" *ngSwitchCase="false">
						<p class="c-text c-text--bold c-text--cut" *ngIf="vm.media.postType==='VIDEO' || vm.media.postType==='PICTURE'">{{ vm.media.originalFileName || vm.media.name }}</p>
						<p class="c-text c-text--bold c-text--cut" *ngIf="vm.media.postType==='DOCUMENT'">{{ vm.media.content || vm.media.originalFileName }}</p>
						<p class="c-text c-text--gray">
							<span *ngIf="vm.media.id">{{ vm.media.size | bytesToSize }} </span>
							<span *ngIf="!vm.media.error && !vm.media.fileUrl">{{ 'Chats.Other.Uploading' | translate }}...</span>
							<span *ngIf="vm.media.error">{{ 'Chats.Errors.Upload' | translate }}</span>
						</p>
						<div *ngIf="!vm.media.fileUrl" class="c-bar u-ost-md" [ngClass]="{'c-bar--s2': vm.media.error, 'c-bar--s1 c-bar--progress': !vm.media.error}"></div>
					</div>
					<div class="c-message__media u-clickable" (click)="vm.handleMediaOpen()" *ngSwitchDefault>
						<i class="c-message__icon" *ngIf="vm.media.postType==='VIDEO' && !vm.mediaOpen">&#9658;</i>
						<img src="{{vm.media.thumbnailUrl}}" alt="{{vm.media.originalFileName}}" class="c-message__image" />
						<loader-overlay *ngIf="vm.loading"></loader-overlay>
					</div>
				</div>
					<div class="c-message__bc c-message__bc--fw" *ngIf="vm.media.deleted" style="width: 100px;">
						<p id="chatSimpleTextMessageItem"
						   class="chatSimpleTextMessageItem c-text c-text--wrap"
						   [ngClass]="{'c-message-deleted': vm.media.deleted}"
						   [innerHtml]="vm.media.content">
						</p>
					</div>
					<div class="chat-actions-menu"
						 *ngIf="vm.media.showActions"
						 (click)="$event.stopPropagation()">
						<button (click)="vm.deleteMessage(vm.media)">
							 {{ 'Modal.Title.Delete' | translate }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="o-grid__cell--w-100" style="padding-bottom:5px;" [ngClass]="{'c-message--right': vm.user?.id===vm.media?.user?.id}" >
	    <span class="c-text c-message--footer">{{vm.media?.created | date:'HH:mm'}}</span>
	    <span *ngIf="vm.user?.id===vm.media?.user?.id" class="c-text c-text--gray c-text--bold c-message--footer" [ngClass]="{'c-message--seen' : vm.media?.id <= vm.lastSeen}">&check;</span>
	</div>
</div>
